// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__h295Q"};